





















































































import Vue from 'vue'
import { BatchDto } from '@/Application/Batch'
import SpeciesRiscoTable from '@/UI/Batch/Species/SpeciesRiscoTable.vue'
import SpeciesResultasTable from '@/UI/Batch/Species/SpeciesResultasTable.vue'

export default Vue.extend({
  name: 'DeclarationsBatchDetail',
  components: { SpeciesRiscoTable, SpeciesResultasTable },
  props: {
    batch: {
      type: BatchDto,
      required: true
    },
    currentProcedureType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    onExpandDetailProcedure (): void {
      this.expanded = !this.expanded
    }
  },
  computed: {
    showFianza (): boolean {
      return this.currentProcedureType === 'PX'
    }
  }
})
